import React, { useContext, useEffect, useState } from 'react'
import { QuizzesSection } from './components/QuizzesSection';
import { sendPageViewEvent } from '../../utils/utils';
import { AppContext } from '../../AppContext';
import './Quizzes.scss';
import './styles/dark.scss';

export function Quizzes() {
  const { user } = useContext(AppContext);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const element = document.querySelector("[data-screen='quizzes']");
    const pageTitle = element?.getAttribute("data-pagetitle") || 'PC Quizzes – PokerCoaching.com';
    
    document.title = pageTitle;

    sendPageViewEvent('PC Quizzes | PokerCoaching.com');
    setIsLoaded(true);
  }, []);

  return isLoaded ? (
    <div className="Quizzes">
      {user.type === 'pcp' ||  (user.type === 'pc' && user.meta?.pc_classic !== true)? (
        <QuizzesSection title="Quizzes" />
      ) : (
        <>
          <QuizzesSection
            id="free"
            title="Free Quizzes"
            constantParams={{
              'filter[column]': 'membership_type',
              'filter[value]': 'free',
              'filter[compare]': '='
            }}
            showSearch={false}
            initRowSize={10}
            showSizeChanger={false}
          />
          <QuizzesSection
            id="standard_premium"
            title="Standard & Premium Quizzes"
            constantParams={{
              'filter[column]': 'membership_type',
              'filter[value]': 'free',
              'filter[compare]': '!='
            }}
            initRowSize={user.type === 'guest' || user.type === 'free' ? 25 : 100}
          />
        </>
      )}
    </div>
  ) : null;
}
